import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { ReadingAidsPopupPropsInState } from '../../types';

export enum AIDefinitionsActionType {
	UPDATE_KEYWORD_REGEX = 'UPDATE_KEYWORD_REGEX',

	UPDATE_KEYWORD_DECORATIONS_SESSION_ID = 'UPDATE_KEYWORD_DECORATIONS_SESSION_ID',

	UPDATE_KEYWORD_DECORATIONS = 'UPDATE_KEYWORD_DECORATIONS',

	OPEN_READING_AIDS_POPUP = 'OPEN_READING_AIDS_POPUP',

	CLOSE_READING_AIDS_POPUP = 'CLOSE_READING_AIDS_POPUP',

	SET_CURRENT_KEYWORD_ID = 'SET_CURRENT_KEYWORD_ID',

	RESET_CURRENT_KEYWORD_ID = 'RESET_CURRENT_KEYWORD_ID',
}

interface UpdateKeywordRegex {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_REGEX;
	keywordRegex: RegExp;
}

interface UpdateSessionId {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS_SESSION_ID;
}

interface UpdateKeywordDecorations {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS;
	keywordDecorations: DecorationSet;
}

interface OpenReadingAidsPopup {
	type: AIDefinitionsActionType.OPEN_READING_AIDS_POPUP;
	// there will be keywordId if opened by clicking decoration, there will be no keywordId if opened by AI define button
	keywordId?: string;
	readingAidsPopupProps: ReadingAidsPopupPropsInState;
}

interface CloseReadingAidsPopup {
	type: AIDefinitionsActionType.CLOSE_READING_AIDS_POPUP;
}

export type AIDefinitionsAction =
	| UpdateKeywordRegex
	| UpdateSessionId
	| UpdateKeywordDecorations
	| OpenReadingAidsPopup
	| CloseReadingAidsPopup;
